module.exports = __webpack_public_path__ + "57065be877caf0d06fbea36d53b63dd4.jpg";